import clsx from "clsx";
import VerticalRule from "../../Rule/Vertical";
import { RentalStockSummary } from "../../../services/rentalStockServices";

export type RentalStockSummaryListProps = {
  summary?: RentalStockSummary;
  size?: "default" | "small";
  wrapperClassName?: string;
};

export const RentalStockSummaryList = ({
  summary,
  wrapperClassName,
  size = "default",
}: RentalStockSummaryListProps) => {
  return (
    <div
      className={clsx([
        wrapperClassName,
        {
          "py-5 w-full": size === "default",
          "w-full": size === "small",
        },
      ])}
    >
      <div className="flex h-[64px] items-center">
        <RentalStockHistorySummaryItem
          size={size}
          count={summary?.totalStockCount ?? 0}
          label="전체"
        />
        <VerticalRule className="!h-full !bg-[#333F48] opacity-10" />
        <RentalStockHistorySummaryItem
          size={size}
          count={summary?.availableCount ?? 0}
          label="대여가능"
        />
        <VerticalRule className="!h-full !bg-[#333F48] opacity-10" />
        <RentalStockHistorySummaryItem
          size={size}
          count={summary?.inUseCount ?? 0}
          label="신청/대여"
        />
        <VerticalRule className="!h-full !bg-[#333F48] opacity-10" />
        <RentalStockHistorySummaryItem
          size={size}
          count={summary?.lostDamagedCount ?? 0}
          isRed={(summary?.lostDamagedCount ?? 0) > 0}
          label="분실/손상"
        />
      </div>
    </div>
  );
};

export type RentalStockHistorySummaryItemProps = {
  size?: "default" | "small";
  count?: number | string;
  label?: string;
  isRed?: boolean;
};

export const RentalStockHistorySummaryItem = ({
  count,
  label,
  size,
  isRed = false,
}: RentalStockHistorySummaryItemProps) => {
  return (
    <div
      className={clsx([
        "px-4 py-[5px] flex flex-col items-center flex-1 min-w-[32px]",
        {
          "gap-2": size === "default",
          "max-w-[64px] gap-1": size === "small",
        },
      ])}
    >
      <div
        className={clsx([
          {
            "text-2xl font-semibold leading-[29px]": size === "default",
            "text-lg font-medium leading-[21px]": size === "small",
            "text-black": !isRed,
            "text-brand-primary-red": isRed,
          },
        ])}
      >
        {count ?? 0}
      </div>
      <div
        className={clsx([
          "text-brand-neutral-50 text-center font-medium min-w-[48px] whitespace-nowrap leading-[17px]",
          {
            "text-sm": size === "default",
            "text-xs": size === "small",
          },
        ])}
      >
        {label}
      </div>
    </div>
  );
};
